module.exports = __webpack_public_path__ + "img/img21.f0587ac0.png";